import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'semantic-ui-react';
import RowCopyButton from '@/components/buttons/RowCopyButton';
import RowDeleteButton from '@/components/buttons/RowDeleteButton';
import { copyDictionaryField, deleteDictionaryField } from '../../dictionaries/actions';
import { resolveCatalogueTemplate } from '../../catalogue/helper';

const DictionaryFieldButtonGroup = ({
  code,
  category,
  dictionaryUUID,
  fieldUUID,
  deleteField,
  copyField,
  disabled,
  template,
}) => (
  <Button.Group
    basic
    icon
  >
    <RowCopyButton
      disabled={disabled}
      entity="dictionary"
      onClick={() => copyField(category, code, dictionaryUUID, fieldUUID, template)}
    />
    <RowDeleteButton
      disabled={disabled}
      entity="dictionary"
      onClick={() => deleteField(category, code, dictionaryUUID, fieldUUID, template)}
    />
  </Button.Group>
);

const mapStateToProps = ({
  catalogues: { templates },
  datasets: { datasets },
}, ownProps) => {
  const { template, editable } = resolveCatalogueTemplate(datasets, templates, ownProps);
  return ({ disabled: !editable, template });
};

const mapDispatchToProps = {
  copyField: copyDictionaryField,
  deleteField: deleteDictionaryField,
};

export default connect(mapStateToProps, mapDispatchToProps)(DictionaryFieldButtonGroup);
